class ProductSelectItemListener {
    // Language: javascript
    // Path: ProductSelectItemListener.js
    // Compare this snippet from EventListener.js:

    get ProductList() {
        return ".gtm-product-list";
    }
    get AllDetailProductSelector() {
        return "gtm-add-to-cart";
    }
    get DefaultEventName() {
        return "click";
    }
    get AddTypes() {
        return {
            category_product_list: "Category Product List",
            related_product_list: "Related Product List",
            lastview_product_list: "LastView Product List",
        };
    }

    constructor(element, eventName = this.DefaultEventName) {
        this.element = element;
        this.eventName = eventName;
    }

    callback() {
        var addtype = document.querySelector(
            ProductSelectItemListener.prototype.ProductList
        )
            ? document.querySelector(
                  ProductSelectItemListener.prototype.ProductList
              ).dataset.addtype
            : null;

        var typeName = ProductSelectItemListener.prototype.AddTypes[addtype];
        const dataLayer = new DataLayer();
        dataLayer.clear();
        var analyticsData = this.dataset.analytics
            ? JSON.parse(this.dataset.analytics)
            : null;

        if (analyticsData && this.dataset) {
            var analticsDataProducts = analyticsData.products
                ? analyticsData.products[0]
                : null;
            var item_list_id = addtype ? addtype : "base";

            var price = Number(
                analticsDataProducts.price
                    ? analticsDataProducts.price.replace(",", ".")
                    : this.dataset.price.replace(",", ".")
            ).toFixed(2);
            var pricewithdiscount = Number(
                analticsDataProducts.pricewithdiscount
                    ? analticsDataProducts.pricewithdiscount.replace(",", ".")
                    : this.dataset.priceWithDiscount.replace(",", ".")
            ).toFixed(2);

            var item = {
                item_id: this.dataset.code
                    ? this.dataset.code
                    : analticsDataProducts.code,
                item_name: analticsDataProducts.name,
                currency: analticsDataProducts.currency,
                item_brand: analticsDataProducts.brand,
                item_category: analticsDataProducts.category,
                item_list_id: item_list_id,
                price: pricewithdiscount,
                quantity: analticsDataProducts.quantity,
            };
            if (analticsDataProducts.categories) {
                var splitCategories =
                    analticsDataProducts.categories.split(";");
                for (var i = 0; i < splitCategories.length; i++) {
                    if (i == 0) {
                        item["item_category"] = splitCategories[i];
                    } else {
                        item["item_category" + i] = splitCategories[i];
                    }
                }
            }
            if (this.dataset.addtype) {
                item["item_list_id"] = this.dataset.addtype;
            }

            if (this.dataset.variant) {
                var variant = JSON.parse(this.dataset.variant);
                if (variant) {
                    item["item_variant"] = Object.values(variant).join(",");
                }
            }
            if (price != pricewithdiscount) {
                item["price"] = price;
                item["discount"] = (price - pricewithdiscount).toFixed(2);
            }

            dataLayer
                .push({
                    // eslint-disable-line
                    event: "select_item",
                    item_list_id: item_list_id,
                    item_list_name: typeName,
                    ecommerce: {
                        items: [item],
                    },
                })
                .then(() => {
                    console.log("GTM pushed select_item event");
                    setTimeout(() => {
                        var instanceActivate = new ActivateGtm();
                        instanceActivate.activateRemoveFromCart();
                    }, 1000);
                })
                .catch((error) => {
                    console.warn("GTM error select_item event", error);
                });

            if (typeof gtag !== "undefined" && !!gtag) {
                gtag("event", "select_item", {
                    event_category: "Enhanced Ecommerce",
                    event_label: "add select_item cart",
                    item_list_id: item_list_id,
                    item_list_name: typeName,
                    items: [item],
                });
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            ProductSelectItemListener.prototype.callback
        );
    }

    remove() {
        this.element.removeEventListener(
            this.eventName,
            ProductSelectItemListener.prototype.callback
        );
    }
}
